<div class="toolbar">
  <mat-form-field appearance="fill" class="info-key-field">
    <mat-label>Select info key</mat-label>
    <mat-select [(ngModel)]="currentKey" (selectionChange)="onKeyChange()">
      <mat-option *ngFor="let key of availableKeys$ | async" [value]="key">{{ key }}</mat-option>
    </mat-select>
  </mat-form-field>

  <div *ngIf="allHeaders.length > 0" class="column-selector">
    <mat-form-field appearance="fill">
      <mat-label>Visible columns</mat-label>
      <mat-select [formControl]="visibleColumnsControl" multiple>
        <mat-option *ngFor="let col of allHeaders" [value]="col">{{ col }}</mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-raised-button color="primary" (click)="toggleSelectAll()">
      {{ isAllSelected() ? 'Deselect All' : 'Select All' }}
    </button>
  </div>
</div>

<app-table-standard-layout
  [dataSource$]="dataSource$"
  [title]="'Systems'"
  [columnSettings]="columnSettings"
  [showImport]="false"
  [rowActionButtons]="rowActionButtons"
>
</app-table-standard-layout>

